import CustomSpinner from '@/common/Spinner';
import { useCreateQuote } from '@/hooks/useCreateQuote';
import { useStore } from '@/providers/storeProvider';
import { getCurrencyCodeByCountry } from '@/utils/currencySwitcher';
import React, { useEffect, useMemo, useState } from 'react';
import { airTracker } from '@/utils/airTracker';
import { COMPONENT_NAME } from '@/pages/Main';

const AutomaticCurrencyConversion: React.FC = ({ children }) => {
  airTracker.info('Enter AutomaticCurrencyConversion Wrapper', {
    component: COMPONENT_NAME,
  });
  const [loading, setLoading] = useState(true);
  const { accCurrencyList, invoiceData, country } = useStore();
  const { invoice, secret: clientSecret } = invoiceData;
  const { currency, totalDueAmount } = invoice;

  const iPCountryCurrency = useMemo(() => getCurrencyCodeByCountry(country), [country]);
  const { createQuoteAction } = useCreateQuote();

  const targetCurrency = useMemo(() => {
    if (iPCountryCurrency) {
      return accCurrencyList.includes(iPCountryCurrency) ? iPCountryCurrency : currency;
    } else {
      return currency === 'EUR' ? 'USD' : 'EUR'; // TODO what if USD and EUR is not in accCurrencyList?
    }
  }, [accCurrencyList, currency, iPCountryCurrency]);

  useEffect(() => {
    const initializeQuote = async () => {
      airTracker.info('initializeQuote', {
        component: COMPONENT_NAME,
        currency,
        targetCurrency,
        totalAmount: totalDueAmount ?? 0,
      });
      if (currency && clientSecret) {
        await createQuoteAction({
          paymentCurrency: currency,
          targetCurrency,
          paymentAmount: totalDueAmount ?? 0,
          clientSecret,
        });
        setLoading(false);
      } else {
        setLoading(false);
      }
    };

    initializeQuote();
  }, [clientSecret, createQuoteAction, currency, targetCurrency, totalDueAmount]);

  if (loading) {
    return <CustomSpinner />;
  }

  return <>{children}</>;
};

const AccWrapper: React.FC = ({ children }) => {
  const isCurrencySwitcherEnabled = false;

  return isCurrencySwitcherEnabled ? (
    <AutomaticCurrencyConversion>{children}</AutomaticCurrencyConversion>
  ) : (
    <>{children}</>
  );
};

export default AccWrapper;
